import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "../../store"
import { AuthResponseDto, LocationDtoResponse, PermissionDto } from "src/graphql/quark/quark.type"

export type AutSliceStateType = AuthResponseDto & { currentWhLoc: LocationDtoResponse | null }

export const getLocalToken = (): string | undefined => {
  const data = localStorage.getItem("token")
  return data && data !== "" && data !== null ? data : undefined
}

const initialState = {
  user: JSON.parse(localStorage.getItem("user") || "{}"),
  tenant: JSON.parse(localStorage.getItem("tenant") || "{}"),
  token: localStorage.getItem("token"),
  permissions: [] as PermissionDto[],
  allowedLocations: [] as LocationDtoResponse[],
  currentWhLoc: null,
  config: {
    currency: "",
    logo: "",
    onlineStoreURL: "",
    parentCompanyLogo: "",
    website: ""
  }
}

export const authSlice = createSlice({
  name: "authentication",
  initialState: initialState as AutSliceStateType,
  reducers: {
    loginState(state: any, { payload }: PayloadAction<AuthResponseDto>) {
      const initialData = { ...payload }

      if (initialData?.token) {
        localStorage.setItem("token", initialData?.token)
        state.token = initialData?.token
      }
      if (initialData?.user) {
        state.user = initialData?.user
        localStorage.setItem("user", JSON.stringify(initialData?.user))
      }
      if (initialData?.tenant) {
        state.tenant = initialData?.tenant
        localStorage.setItem("tenant", JSON.stringify(initialData?.tenant))
      }
      // if (initialData?.config) {
      //   state.config = initialData?.config
      //   localStorage.setItem("config", JSON.stringify(initialData?.config))
      // }
      if (initialData?.permissions) state.permissions = [...(initialData?.permissions ?? [])]

      if (initialData?.allowedLocations) {
        state.allowedLocations = [...initialData.allowedLocations].sort((a, b) =>
          (a.name ?? "").localeCompare(b.name ?? "")
        )
      }
    },
    updateWhLoc: (state: any, { payload }: PayloadAction<LocationDtoResponse>) => {
      state.currentWhLoc = payload
    },
    logoutState: (state: any) => {
      state.user = {}
      state.token = null
      state.permissions = []
      state.tenant = {}
      state.allowedLocations = []
      state.currentWhLoc = null
      localStorage.removeItem("token")
      localStorage.removeItem("user")
      localStorage.removeItem("tenant")
      localStorage.removeItem("warehouseId")
      localStorage.removeItem("retailId")
      localStorage.removeItem("config")
      localStorage.removeItem("permissions")
      localStorage.removeItem("allowed-locations")
    }
  }
})

export const authReducer = authSlice.reducer

export const { loginState, logoutState, updateWhLoc } = authSlice.actions

export const getUserState = (state: RootState) => state.authentication.user
